import { Button } from '@repo/go-ui';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { SyncWithDb } from './sync-with-db';

import styles from '../plugins.module.scss';

const SyncButton = wrap<{ pluginController: SyncWithDb }>(function RenderButton({ pluginController }) {
  const { t } = useTranslation();

  return (
    <Button
      className={styles.syncWithDbButton}
      onClick={pluginController.syncWithDb}
      disabled={pluginController.tableMediator?.selectedRows.length === 0}
      loading={pluginController.isLoading}
      style={{ textWrap: 'nowrap' }}
    >
      {t('plugins:SyncWithDb.button')}
    </Button>
  );
});

export function renderSyncButton(pluginController: SyncWithDb) {
  return <SyncButton pluginController={pluginController} />;
}
